import styled from "styled-components";

export const EditorWrapper = styled.section`
  flex-basis: 50%;
  height: 100%;
`;

export const SectionTitle = styled.h1`
  padding: 2rem;
  text-align: center;
  font-size: 4.2rem;
`;
